import React from 'react'
import { useSelector } from 'react-redux'
import RootState from '../../../interfaces/RootState'
import SelectField from '../../common/SelectField'

type Props = {
  handleChange: (field: string, value: string) => void,
  values: {
    [key: string]: string
  }
}

const LineOfCoverageFields: React.FC<Props> = ({ handleChange, values }) => {
  const productLines = (state: RootState) => state.login.session.configuration.censuses.product_lines
  const audiences = (state: RootState) => state.login.session.configuration.censuses.product_line_audiences
  const productLinesOptions = useSelector(productLines)
  const audienceOptions = useSelector(audiences)

  const audienceFieldOptions = () => {
    if (values.line_of_coverage) {
      return audienceOptions[values.line_of_coverage]
    }

    return []
  }

  return (
    <>
      <SelectField
        name="line_of_coverage"
        label="Line of Coverage *"
        handleChange={handleChange}
        options={productLinesOptions}
        value={values.line_of_coverage}
      />

      <SelectField
        name="audience"
        label="Audience"
        handleChange={handleChange}
        options={audienceFieldOptions()}
        value={values.audience}
      />
    </>
  )
}

export default LineOfCoverageFields
